$( document ).ready(function() {

  $('.tab').on('click', function(evt) {
      evt.preventDefault();
      $(this).addClass('active');
       $(this).siblings().removeClass('active');
      var sel = this.getAttribute('data-toggle-target');
      $('.tab-content').removeClass('active').filter(sel).addClass('active');
    });

  setTimeout(function() {
    $('.installment').appendTo('.zenrush-container');
      $('.back-stock-trigger').click(function(){
        $('.bis-form-wrap').slideToggle();
    });
  }, 500);

  
  $('.vertical-thumbnail-slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 4,
            vertical: false,
            verticalSwiping: false,
          }
        }
      ]
    });

  if (window.matchMedia("(max-width: 850px)").matches) {
    $('.text-with-icons-slider').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  } 
  
  if (window.matchMedia("(max-width: 850px)").matches) {
    // $('.multicolumn-list').slick({
    //   infinite: false,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   arrows: false,
    //   dots: true,
    //   responsive: [
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         autoplay: false
    //       }
    //     }
    //   ]
    // });

    $('.mb-additional-products').slick({
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true
    });

    
  } 


  setTimeout(function() {

    $('.bundles-slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      nextArrow: '<button type="button" class="slick-next"><i class="fa-regular fa-chevron-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="fa-regular fa-chevron-left"></i></button>',
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    });
  }, 1000);

  

  $('.logo-col-dt-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
     autoplay: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          speed: 2000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          dots: true,
          initialSlide: 1,
          arrows: false,
          buttons: false
        }
      }
    ]
  });

  
  // if (window.matchMedia("(max-width: 850px)").matches) {

  //   $('.logo-col').slick({
  //     speed: 2000,
  //     autoplay: true,
  //     autoplaySpeed: 0,
  //     centerMode: true,
  //     cssEase: 'linear',
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     variableWidth: true,
  //     infinite: true,
  //     dots: true,
  //     initialSlide: 1,
  //     arrows: false,
  //     buttons: false
  //     });
  // }


  $('.iwts-marquee').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
  });

  if (window.matchMedia("(max-width: 850px)").matches) {


    
      $('.mb-slider-content').slick({
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: true
      })


    $('.logo-row .logo-col').slick({
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      dots: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
  });

    
}



  $('.additional-products-slider').slick({
    infinite: true,
    autoplay: false,
    arrows: false,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });


  
  $('.image-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1, 
    arrows: true,
    prevArrow: $(".pp2"),
    nextArrow: $(".nn2"),
    fade: true
  });
  
  $('.testimonial-row').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  Fancybox.bind('[data-fancybox="images"]', {
  });

 $("#toc").toc({content: "div.article-content", headings: "h2"});
  
   
});